import { PackPermission } from "domains/pack";

const sharedIdentifier = 'x';

export const isSharedPack = (packId: string) => packId && packId.startsWith(sharedIdentifier);
export const isAdmin = (pack: any) => pack?.permission === PackPermission.ADMIN;
export const isOwner = (pack: any, user: any) => pack?.permission === PackPermission.ADMIN && pack.user.id === user?.id;
export const isCollaborator = (pack: any) => pack?.permission === PackPermission.COLLABORATION;
export const isReadOnly = (pack: any) => pack?.permission === PackPermission.READ_ONLY;
export const isPreviewingPack = (pathname) => pathname === '/packs/[id]/preview';
export const isSharedURL = (pathname) => pathname.startsWith(sharedIdentifier);

export const needOldPassword = (pack: any, user: any) => {
    const compareKeys = !isSharedPack(pack?.id) || pack?.join_key;

    return pack?.is_encrypted && compareKeys && user?.key_id && user.key_id !== pack?.key_id;
}